import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const accessToken = rest.accessToken
  return (
    <Route
      {...rest}
      render={props => {
        return (
          accessToken ? <Component {...props} {...rest} /> : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />)
        )}
      }
    />
  );
};

export default ProtectedRoute;